import moment from 'moment'

export const formatDuration = (duration: number) => {
  const totalDuration = moment.duration(duration, 'seconds')
  const minutes = totalDuration.minutes()
  const seconds = totalDuration.seconds()

  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}
